import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <section className="section bg-theme-dark tc-light" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center' }}>
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-6">
            <h1 className="title title-xl-2 mb-3" style={{ fontSize: '6rem' }}>404</h1>
            <h2 className="title mb-4">Barangay Not Found</h2>
            <p className="lead mb-5">
              The barangay you're looking for doesn't exist or may have been removed.
            </p>
            <Link to="/" className="btn btn-lg btn-grad btn-round">
              <em className="fas fa-home me-2"></em>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default NotFound
